import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  message: null,
  error: null,
  data: [],
};

const getTravelRelationSlice = createSlice({
  name: "getTravelRelation",
  initialState,
  reducers: {
    getTravelRelationStart(state, payload) {
      state.loading = true;
      state.error = null;
      state.message = null;
    },

    getTravelRelationSuccess(state, action) {
      state.loading = false;
      const flattenedArray = []?.concat(...action?.payload);
      state.data = flattenedArray;
      state.message = action.payload.message;
    },
    getTravelRelationFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
      state.message = null;
    },
    clearError: (state) => {
      state.error = null;
    },
    clearMessage: (state) => {
      state.message = null;
    },
  },
});

export const {
  getTravelRelationStart,
  getTravelRelationSuccess,
  getTravelRelationFailure,
  clearError,
  clearMessage,
} = getTravelRelationSlice.actions;

export default getTravelRelationSlice.reducer;
